/**
 * Represents the refund status of an [[OrderLine]].
 */
export var OrderLineRefundStatus;
(function (OrderLineRefundStatus) {
    /**
     * Order line has not been refunded.
     */
    OrderLineRefundStatus["NotRefunded"] = "NotRefunded";
    /**
     * Order line has been refunded.
     */
    OrderLineRefundStatus["Refunded"] = "Refunded";
})(OrderLineRefundStatus || (OrderLineRefundStatus = {}));
//# sourceMappingURL=order-line-refund-status.js.map